import { useState } from 'react';
import styled from 'styled-components';
import EventTeaser from '../../molecules/EventTeaser';
import { mq } from '~/styles/grid';
import Row from '~/grid/Row';
import Col from '~/grid/Col';
import SelectBox from '../../atoms/SelectBox';
import CTA from '../../atoms/CTA';
import { CTATag } from '../../atoms/CTA/CTA.constants';
import { useIntl } from 'react-intl';

const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;

  @media (${mq.smDown}) {
    flex-direction: row;
    margin-bottom: 30px;
  }
  /* needed to get specificity to override breakpoint-specific paddings */
  @media (min-width: 0px) {
    padding: 0;
  }
`;

const StyledCTA = styled(CTA)`
  margin-top: 40px;

  @media (${mq.smDown}) {
    margin-top: 30px;
    width: 100%;
    button {
      width: 100%;
      display: block;
    }
  }
`;

const StyledSelect = styled(SelectBox)`
  .select__control {
    min-width: 300px;

    @media (${mq.xs}) {
      min-width: 325px;
      max-width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  width: 80%;

  @media (${mq.lgDown}) {
    width: 100%;
  }
`;

const eventsChunkSize = 5;

/**
 * @param {EventOverviewProps} props
 * @returns {React.ReactElement} The rendered component
 */
const EventOverview = ({ targetGroupSelector, locationSelector, events }) => {
  const [displayAmount, setDisplayAmount] = useState(eventsChunkSize);
  const intl = useIntl();
  const loadMore = intl.formatMessage({
    id: 'main.loadMore',
  });

  const withHiddenEvents = events.length > displayAmount;
  const visibleEvents = withHiddenEvents
    ? events.slice(0, displayAmount)
    : events;

  const selectBoxColumnWidth = targetGroupSelector && locationSelector ? 6 : 8;
  return (
    <Wrapper>
      {(targetGroupSelector || locationSelector) && (
        <FilterContainer>
          <Row>
            {targetGroupSelector && (
              <Col
                colAmount={{
                  xl: selectBoxColumnWidth,
                  lg: selectBoxColumnWidth,
                  md: selectBoxColumnWidth,
                  sm: selectBoxColumnWidth,
                  xs: 12,
                }}
              >
                <StyledSelect {...targetGroupSelector} />
              </Col>
            )}
            {locationSelector && (
              <Col
                colAmount={{
                  xl: selectBoxColumnWidth,
                  lg: selectBoxColumnWidth,
                  md: selectBoxColumnWidth,
                  sm: selectBoxColumnWidth,
                  xs: 12,
                }}
              >
                <SelectBox {...locationSelector} />
              </Col>
            )}
          </Row>
        </FilterContainer>
      )}

      {visibleEvents.map((event, idx) => (
        <EventTeaser key={`${event.title}_${idx}`} {...event} />
      ))}
      {withHiddenEvents && (
        <StyledCTA
          skin="SECONDARY"
          text={loadMore}
          title={loadMore}
          type={CTATag.Button}
          handleBtnClick={() =>
            setDisplayAmount(displayAmount + eventsChunkSize)
          }
        />
      )}
    </Wrapper>
  );
};

export default EventOverview;
